<template>
    <div id="wrapper">
        <link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
    <!-- Sidebar -->
        <nav class="navbar-default navbar-static-side" style="position: relative;">
            <div class="p-2 logoBox" style="height: 62px;" >
                <b-navbar-brand >Sedna Partner Portal</b-navbar-brand>
            </div>
            <div class="sidebar-collapse">
                <ul class="nav metismenu" id="side-menu">
                    <li class="nav-header"></li>
                    <li v-if="$auth.isAuthenticated">
                        <a href="#/rfqs">
                            <i class="fa fa-envelope"></i>
                            <span class="nav-label">Your RFQs</span>
                        </a>
                    </li>
                    <li v-if="$auth.isAuthenticated">
                        <a href="#/quotes" >
                            <i class="fa fa-dollar"></i>
                            <span class="nav-label">Your Quotes</span>
                        </a>
                    </li>
                    <li v-if="$auth.isAuthenticated">
                        <a href="#/files" >
                            <i class="fa fa-file"></i>
                            <span class="nav-label">Files</span>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
        <!-- End Sidebar -->
        <div id="page-wrapper"   >
            <div class="row page-wrapper-row">
                <div class="top-bar" style="position: relative; z-index: 999;">
                    <b-navbar class="navbar-default">
                        <b-navbar-nav class="ml-auto">
                            <b-nav-item-dropdown v-if="cageOptions.length != 0" :text="selected" style="margin-right:20px;">
                                <b-dropdown-item v-on:click="changeCode(cageOption.name, cageOption.id)" v-for="cageOption in cageOptions" :value="cageOption.id" :key="cageOption.id">{{cageOption.name}}</b-dropdown-item>
                            </b-nav-item-dropdown>
                            <b-nav-text v-if="$auth.isAuthenticated">{{$auth.user.name}}</b-nav-text>
                            <b-nav-item @click="modalVisible=true" >"How To"</b-nav-item>
                           <!--  <b-nav-item href="https://www.atlassian.com/software/jira" target="_blank">Need Tech Support?</b-nav-item> -->
                            <b-nav-form>
                                <a v-if="$auth.isAuthenticated" class="btn btn-outline-light btn-sm login-btn" @click="logout">Sign out</a>
                                <a v-else class="btn btn-outline-light btn-sm login-btn" @click="login">Sign in</a>
                            </b-nav-form>
                        </b-navbar-nav>
                    </b-navbar>

                </div>
            </div>

            <div class="wrapper wrapper-content">
                
                <div class="container" style="background: transparent;">
                <b-alert show style="background-color: #fad2bb">
                <h5 class="alert-heading">Notice</h5>
                <p class="mb-0">
                Solicitation specific requirements can now be viewed in our Vendor Portal.  They will be listed in the Opportunity requirements section located on the bottom of each RFQ by 11 AM Est Time.
                </p>
                </b-alert>
                </div>
                
                <div class="container pageContentBox  main-content" >
                    <router-view v-on:onError="onError"></router-view>
                </div>
            </div>

            
            
            <whats-new v-model="modalVisible"/>
            <error-view v-model="error" v-bind:disable_dismiss="error_disable_dismiss"/>
            
            <div class="footer">
                <div class="d-flex justify-content-center">
                    <link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
                    <img class="img-fluid logoStyle" src="/Blue Raven Logo - Full Color Stacked.png" width="10%" />
                </div>
            </div>
             
        </div>

        
    
    
    </div>
</template>

<script>
//import LayoutFooter from '@/components/core/LayoutFooter'
import WhatsNew from '@/views/WhatsNew'
import ErrorView from '@/components/common/ErrorView';
import { datadogLogs } from '@datadog/browser-logs';
import { getInstance } from '../auth';

const PortalApi = require("@brightoncromwell/portal-api");
const apiInstance = new PortalApi.Auth0UserApi();
let defaultClient = PortalApi.ApiClient.instance;

export default {
    name: 'app-layout-platform', 
    components: {
        //'app-layout-footer': LayoutFooter,
        'whats-new': WhatsNew,
        'error-view': ErrorView
    },
    data() {
        return {
            modalVisible: false,
            error: null,
            error_disable_dismiss: false,
            cageOptions: [],
            selected: null
        }
    },
    methods: {
        onError: function(response, disableDismiss) {
            datadogLogs.logger.info('Error shown to user', { response: response });

            if (response) {
                if (response.status === 401) {
                this.$router.push("/signin")
                }
                else {
                    this.error = response.body;
                    this.error_disable_dismiss = disableDismiss
                }
            }
            else {
                this.error = {error_message:"An unknown error occured", request_id: "0"};
            }
        },
        changeCode: function(name, value) {
            localStorage.setItem('selected_company_id', value);
            localStorage.setItem('selected_label', name);
            this.selected = name;
            location.reload();
        },
        async getCageCodes(oscope) {
            const token = await this.getToken();
            let BearerAuth = defaultClient.authentications['BearerAuth'];
            BearerAuth.accessToken = token;
            let userId = this.$auth.user.sub;

            apiInstance.userinfoCompaniesGet(userId, (error, data, response) => {
            if (error) {
                datadogLogs.logger.error('userinfoCompaniesGet() failed', { userId: userId,  error: error });
                this.$emit('onError', response, true)
            } else {
                let cages = Object.entries(response.body);

                cages.map(function(element) {

                    oscope.cageOptions.push({ name: element[0], id: element[1] });
                });
                oscope.selected = localStorage.getItem('selected_label');

                if (oscope.selected == null) {
                    oscope.changeCode(oscope.cageOptions[0].name, oscope.cageOptions[0].id);
                }
            }
            });
        },
        getToken: async function(){
            return new Promise((resolve, reject) => {
                const instance = getInstance();
                if(instance.loading == false){
                resolve(instance.getTokenSilently());
                // Redirect if the user isn't authenticated
                if (!instance.isAuthenticated){
                    window.location.href = "/signin";
                }
                }
                else{
                instance.$watch("loading", loading => {
                    if (loading == false && instance.isAuthenticated){
                    instance.getTokenSilently().then(authToken => {resolve(authToken);}).catch(error => {reject(error);});
                    }
                    // Redirect if the user isn't authenticated
                    else if (!instance.isAuthenticated){
                    window.location.href = "/signin";
                    }
                });
                }
            });
        },
        login() {
            this.$auth.loginWithRedirect();
        },
        logout() {
            this.$auth.logout({
            returnTo: window.location.origin
        });
    },
    },
    computed: {
        sessionUsername: function() {
            let username = null;
            const sessionJSON = localStorage.getItem('session') || '';
            if (sessionJSON.length) {
                const session = JSON.parse(sessionJSON);
                const sessionUsername = session.username || '';
                if (sessionUsername.length) {
                    username = sessionUsername;
                } 
            }
            return username;
        },
        publicRoute: function() {
            const routeName = this.$route.name || '';
            return routeName.startsWith('public');
        }
    },
    mounted () {
    },
    created (){
        let oscope = this;
        this.getCageCodes(oscope);
        document.onreadystatechange = async function () {
            const instance = getInstance();
            instance.$watch("loading", loading => {
            if (loading == false && !instance.isAuthenticated){
              window.location.href = "#/signin";
            }
          });
        }
    }
}

</script>

<style scoped>
.main-content {
    padding-bottom: 150px;
}

#footer {position: relative;
	margin-top: -150px; /* negative value of footer height */
	height: 150px;
	clear:both;} 

.nav > li > a i {
    margin-right: 10px;
    text-align: center;
    width: 26px;
}

.logoStyle {
    margin-top: 12px;
    margin-left: 12px;
}

.logoCopyright {
    margin-left: 12px;
    vertical-align: bottom;
    color: #dddddd;
}

.logoBox {
    border-bottom: 2px solid #003087;
}

.footerLinkTitle {
    color: inherit;
}

.page-wrapper-row {
    margin: 0px;
}
</style>